<template>
  <v-row>
    <v-col cols="12">
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="refreshDrafts"
                v-bind="attrs"
                v-on="on"
                ><v-icon>mdi-refresh</v-icon></v-btn
              >
            </template>
            <span>Refresh</span>
          </v-tooltip>
        </v-row>
        <template v-for="(draft, index) in drafts">
          <div :key="index">
            <v-list-item three-line @click="selectDraft(draft)">
              <v-list-item-content>
                <v-list-item-title>{{
                  draft.title || "No Title."
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  draft.body || "No Body."
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>
                    <div v-if="draft.users != null && draft.users.length > 0">
                      Users Email(s):
                      <template v-for="(history, ind) in draft.users">
                        <span :key="ind" class="mr-1">
                          {{history.user.email}}
                        </span>
                      </template>
                    </div>   
                    <div v-if="draft.users == null || draft.users.length <= 0">
                      No Users.
                    </div>   
                    <div>
                      Saved at {{ formatDatetime(draft.created_at) }}
                    </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="draft.length - 1 !== index"
            ></v-divider>
          </div>
        </template>
        <infinite-loading
          :identifier="draftsScrollOptions.id"
          @infinite="getDrafts"
          spinner="spiral"
        >
          <template v-slot:no-results>
            <div class="text-center"></div>
          </template>
        </infinite-loading>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>

import { GET_NOTIFICATION_HISTORY } from "@/views/csr/store/typeDefs/notification";
import utilityMixin from "@/views/csr/mixins/utility";

const defaultForm = {
  title: null,
  date: null,
  time: null,
  body: null,
  isButton: false,
  buttonName: null,
  linkName: null,
  id: null
};

export default {
  name: 'Drafts',
  mixins: [utilityMixin],
  data() {
    return {
      form: Object.assign({}, defaultForm),
      draftsScrollOptions: {
        page: 1,
        id: +new Date(),
      },
      drafts: [],
    }
  },
  methods: {
    async refreshDrafts() {
      this.drafts = [];
      this.draftsScrollOptions = Object.assign(this.draftsScrollOptions, {
        page: 1,
        id: this.draftsScrollOptions.id + 1,
      });
    },

    selectDraft(draft) {
      this.form = Object.assign(
        {},
        {
          id: draft.id,
          title: draft.title,
          date: draft.datetime.split(" ")[0],
          time: draft.datetime.split(" ")[1],
          body: draft.body,
        }
      );

      this.$emit('select', {
        form: this.form,
        tabIndex: 0,
        users: draft.users
      });
    },
    
    async getDrafts($state) {
      const payload = {
        page: this.draftsScrollOptions.page,
        type: "draft"
      };
      let gotDrafts = await this.$store.dispatch(
        GET_NOTIFICATION_HISTORY,
        payload
      );

      this.drafts = [...this.drafts, ...gotDrafts];
      if (gotDrafts.length === 15) {
        this.draftsScrollOptions.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    }
  }
}
</script>